module.exports = __webpack_public_path__ + "img/slider_7.ac5ea6bf.jpg";